import { graphqlRequest } from "./graphql";

interface RegisterResponse {
  registerWithoutPassword: {
    request_id: string;
    status: string;
  };
}

interface VerifyOTPResponse {
  verifyOTP: {
    auth_token: string;
    id: string;
    status: string;
  };
}

export interface UserData {
  id: string;
  fullname: string;
  phone: string;
  email: string;
  dp: string;
  username: string;
}

interface GetUserDataResponse {
  auth: UserData[];
}

export async function sendOTP(phone: string) {
  const query = `
    mutation Register($phone: String!) {
      registerWithoutPassword(credentials: {phone: $phone}) {
        request_id
        status
      }
    }
  `;
  const data = await graphqlRequest<RegisterResponse>(query, { phone });
  return data.registerWithoutPassword;
}

export async function verifyOTP(phone: string, otp: string) {
  const query = `
    mutation VerifyOTP($phone: String!, $otp: String!) {
      verifyOTP(request: {otp: $otp, phone: $phone}) {
        auth_token
        id
        status
      }
    }
  `;
  const data = await graphqlRequest<VerifyOTPResponse>(query, { phone, otp });
  return data.verifyOTP;
}

export async function getUserData(id: string, token: string) {
  const query = `
    query GetUserData($id: uuid!) {
      auth(where: {id: {_eq: $id}}) {
        id
        fullname
        phone
        email
        dp
        username
      }
    }
  `;
  const data = await graphqlRequest<GetUserDataResponse>(query, { id }, token);
  return data.auth[0] ?? null;
}
